module.exports = __webpack_public_path__ + "static/media/facebook.85978548.svg";